import * as R from 'ramda';


/**
 * Ensures that the value of each 'key' or path in each object in the provided
 * collection is the same. If so, an object with each checked key is
 * returned with the uniform values. Otherwise, returns false.
 *
 * TODO: Move to utils library.
 *
 * @example
 *
 * let foo = {a: 1, b: 2, c: 3};
 * let bar = {a: 1, b: 2, c: 27};
 *
 * areUniform(['a', 'b'], [foo, bar]) => {a: 1, b:2}
 * areUniform(['c'], [foo, bar]) => false
 *
 * @example
 *
 * let foo = {
 *   a: {
 *     b: true,
 *     c: false
 *   }
 * };
 *
 * let bar = {
 *   a: {
 *     b: true,
 *     c: true
 *   }
 * };
 *
 * areUniform([['a', 'b']], [foo, bar]) => {
 *   a: {
 *     b: true
 *   }
 * }
 *
 * @param {array} paths - List of keys or paths to inspect for uniformity.
 * @param {array} xs - Collection.
 * @return {*} - The uniform value of all 'keys' in collection, or false.
 */
function areUniform(paths, xs) {
  return R.reduce((acc, path) => {
    // Ensure path is always an array.
    path = [].concat(path);

    // Get a list of unique values at 'path' from each member of the collection.
    const values = R.uniq(R.map(R.path(path), xs));

    // If there is only one unique value, assign it to the return value.
    return values.length === 1 ? acc && R.assocPath(path, R.head(values), acc) : false;
  }, {}, paths);
}


export default areUniform;



// WEBPACK FOOTER //
// ./src/lib/areUniform.js